import { motion } from 'framer-motion';

const MILESTONE_COLORS = {
  reported: '#1E90FF',
  analyzed: '#FFB300',
  dispatched: '#FFB300',
  onScene: '#FF3B3B',
  resolved: '#00C896',
};

export default function IncidentTimeline({ incident }) {
  const milestones = [
    { key: 'reported', label: 'Report Received', time: 'T+0:00', icon: '📡', color: '#1E90FF' },
    { key: 'analyzed', label: 'AI Analyzed', time: 'T+0:12', icon: '🧠', color: '#FFB300' },
    { key: 'dispatched', label: 'Responder Dispatched', time: 'T+0:45', icon: '🚒', color: '#FFB300' },
    { key: 'onScene', label: 'On Scene', time: 'T+3:20', icon: '📍', color: '#FF3B3B' },
    { key: 'resolved', label: 'Incident Resolved', time: 'T+12:30', icon: '✅', color: '#00C896' },
  ];

  return (
    <div className="relative pl-10 space-y-0">
      <div className="timeline-line" />
      {milestones.map((m, i) => (
        <motion.div
          key={m.key}
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.12 }}
          className="relative flex items-start gap-4 pb-6"
        >
          {/* Node */}
          <div
            className="absolute -left-10 w-9 h-9 rounded-full flex items-center justify-center text-base z-10 border-2"
            style={{
              background: `${m.color}20`,
              borderColor: m.color,
              boxShadow: `0 0 10px ${m.color}40`,
            }}
          >
            {m.icon}
          </div>

          {/* Content */}
          <div className="pt-1 ml-2">
            <div className="flex items-center gap-2 mb-0.5">
              <span className="font-semibold text-sm text-white">{m.label}</span>
              <span className="text-xs font-mono" style={{ color: m.color }}>{m.time}</span>
            </div>
            <div className="text-xs text-gray-400">
              {m.key === 'reported' && 'Citizen report received via mobile app + IoT sensor correlation'}
              {m.key === 'analyzed' && 'Gemini AI processed incident data — threat level: HIGH (8/10)'}
              {m.key === 'dispatched' && 'Unit Bravo-3 assigned — optimal route calculated via live traffic'}
              {m.key === 'onScene' && 'Responder arrived — active triage initiated, perimeter secured'}
              {m.key === 'resolved' && 'All clear confirmed — post-crisis learning pipeline triggered'}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
